import React, { FC, useContext, useState } from 'react'
import { GuestContext } from '../Guest.context'
import { ButtonCaption, EmailInputContainer, Link, Title } from './GuestTimeDiscount.style'
import { EmailInput, Container } from '../components'
import { Button, BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'
import { useSetupGuestContext } from '../hooks'
import FormPlateInput from 'parkdepot-shared/components/LPInput'
import { validateEmail } from '@utils/validateEmail.utils'
import { useHistory } from 'react-router-dom'
import { guestRegistrationRoute } from '../route'
import HelpDrawer from '@views/Carpay/Home/components/HelpDrawer.component'
import { useAuth } from '@context/AuthContext/AuthContext'
import FullScreenLoader from '@components/FullScreenLoader/FullScreenLoader.component'
import { Trans, useTranslation } from 'react-i18next'
import { ValidUntil } from '../components/ValidUntil.component'

export const GuestTimeDiscount: FC = () => {
    useSetupGuestContext()
    const { user } = useAuth()
    const { updateFormData, formData, applyWhiteList, loading, endDateFormatted, durationFormatted } =
        useContext(GuestContext)
    const history = useHistory()
    const [emailError, setEmailError] = useState<boolean>(false)
    const [plateError, setPlateError] = useState<string>()
    const [isHelpDrawerOpen, setIsHelpDrawerOpen] = useState(false)
    const { t } = useTranslation()
    const { country, email, plate } = formData || {}

    const handleSubmit = () => {
        if (email && !validateEmail(email)) {
            setEmailError(true)
            return
        }
        if (!plate) {
            setPlateError('Bitte geben Sie Ihr Kennzeichen ein')
            return
        }

        updateFormData({ email, plate, country })
        if (user) {
            applyWhiteList()
        } else {
            history.push(guestRegistrationRoute())
        }
    }

    if (loading) {
        return <FullScreenLoader />
    }

    return (
        <Container>
            <Title>
                <Trans
                    i18nKey="guest.timeDiscountTitle"
                    values={{
                        duration: durationFormatted
                    }}
                />
            </Title>
            <ValidUntil tKey={'guest.validUntil'} endDate={endDateFormatted || ''} />
            <FormPlateInput
                error={plateError}
                value={plate}
                onChange={(plate) => updateFormData({ plate })}
                country={country}
                onCountryChange={(country) => updateFormData({ country })}
            />
            <EmailInputContainer>
                <EmailInput
                    label={t('guest.emailLabel')}
                    caption={t('guest.emailCaption')}
                    value={email}
                    onChange={(e) => updateFormData({ email: e.target.value })}
                    error={emailError}
                />
            </EmailInputContainer>
            <Button $size={BUTTON_SIZE.medium} $kind={BUTTON_KIND.primary} onClick={handleSubmit}>
                {t('guest.submitButton')}
            </Button>
            <ButtonCaption>{t('guest.buttonCaption')}</ButtonCaption>
            <Link role="button" onClick={() => setIsHelpDrawerOpen(true)}>
                {t('guest.buttonDrawer')}
            </Link>
            <HelpDrawer isOpen={isHelpDrawerOpen} onClose={() => setIsHelpDrawerOpen(false)} />
        </Container>
    )
}
